const promiseCache = new Map<string, Promise<any>>();

export const cachedPromiseCreator = (key: string, promiseCreator: () => Promise<any>) => {
  if (promiseCache.has(key)) {
    return promiseCache.get(key);
  }
  const promise = promiseCreator();
  promise.catch(() => {
    promiseCache.delete(key);
  });
  promiseCache.set(key, promise);
  return promise;
};
